import React from 'react'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import { MEDIA_BASE_URL } from '../../../config/constants'

import { PageInfo } from '../../components/PageInfo/PageInfo'
import { Page } from '../../components/Page/Page'
import { SectionBlock } from '../../components/SectionBlock/SectionBlock'

import './ContactPage.css'

const ContactPage = ({ t }) => {
    const iframe = `<iframe class="rc-contact-section-map" src="https://maps.google.com/maps?q=${t(
        'contactPage.address'
    )}&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>`

    return (
        <Page title={t('contactPageTitle')} description={t('contactPageDescription')}>
            <PageInfo
                breadcrumbs={t('contactPage.breadcrumbs')}
                title={t('contactPage.title')}
                bgImage="/images/kontakti.jpg"
                overlay
            />
            <SectionBlock withContainer>
                <div className="contact-page__sections container-1280 gray-bg">
                    <div className="contact-page__sections__details">
                        <h4>{t('contactPage.name')}</h4>
                        <p>{t('contactPage.address')}</p>
                        <p>{t('contactPage.tel')}</p>
                        <p>
                            E-mail:{' '}
                            <a href={`mailto:${t('contactPage.email')}`}>
                                {t('contactPage.email')}
                            </a>
                        </p>
                        <a
                            className="contact-page__sections__details__pdv-form"
                            href={`${MEDIA_BASE_URL}PKS PDV obrazac.pdf`}
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            {t('contactPage.PDVform')}
                        </a>
                    </div>
                    <div className="contact-page__sections__map">
                        <div dangerouslySetInnerHTML={{ __html: iframe }} />
                    </div>
                </div>
            </SectionBlock>
        </Page>
    )
}

ContactPage.propTypes = {
    t: PropTypes.func
}

export default withTranslation()(ContactPage)
